import React, { createContext, useState } from 'react';

export const SystemActionsContext = createContext();

export const SystemActionsProvider = ({ children }) => {
  const [page, setPage] = useState(1);
  const [filterBody, setFilterBody] = useState();
  const [idFilter, setIdFilter] = useState([]);
  const [actionNameFilter, setActionNameFilter] = useState([]);
  const [categoryFilter, setCategoryFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [startedAtLtFilter, setStartedAtLtFilter] = useState();
  const [startedAtGtFilter, setStartedAtGtFilter] = useState();
  const [endedAtLtFilter, setEndedAtLtFilter] = useState();
  const [endedAtGtFilter, setEndedAtGtFilter] = useState();
  const [durationMsFilter, setDurationMsFilter] = useState([]);
  const [sortOrder, setSortOrder] = useState('asc');

  const clearFilters = callback => {
    setIdFilter([]);
    setActionNameFilter([]);
    setCategoryFilter([]);
    setStatusFilter([]);
    setStartedAtGtFilter();
    setStartedAtLtFilter();
    setEndedAtGtFilter();
    setEndedAtLtFilter();
    setDurationMsFilter([]);
    setFilterBody();

    if (callback) callback();
  };

  return (
    <SystemActionsContext.Provider
      value={{
        page,
        setPage,
        filterBody,
        setFilterBody,
        idFilter,
        setIdFilter,
        actionNameFilter,
        setActionNameFilter,
        categoryFilter,
        setCategoryFilter,
        statusFilter,
        setStatusFilter,
        startedAtLtFilter,
        setStartedAtLtFilter,
        startedAtGtFilter,
        setStartedAtGtFilter,
        endedAtLtFilter,
        setEndedAtLtFilter,
        endedAtGtFilter,
        setEndedAtGtFilter,
        durationMsFilter,
        setDurationMsFilter,
        sortOrder,
        setSortOrder,
        clearFilters,
      }}
    >
      {children}
    </SystemActionsContext.Provider>
  );
};
